export default __webpack_public_path__ + "static/media/Entrance2.7434dfd7.jpeg";